import styled from 'styled-components';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Grid from '../common/Grid';
import Input from '../common/forms/Input';
import Submit from '../common/forms/Submit';
import { useLogin } from '../../hooks/useLogin';
import { useIntl } from 'react-intl';
const Form = () => {
	const { performLogin } = useLogin();
	const { formatMessage } = useIntl();
	return (
		<Wrap>
			<Logo>
				<img
					src="/images/wilma.png"
					alt="Wilma"
				/>
			</Logo>
			<Title>
				<h1>
					<span>{formatMessage({ id: 'forms.loginTitle' })}</span>
				</h1>
				<p>{formatMessage({ id: 'forms.welcomeMessage' })}</p>
			</Title>
			<Formik
				initialValues={{
					email: '',
					password: '',
				}}
				validationSchema={Yup.object({
					email: Yup.string()
						.email(formatMessage({ id: 'errors.invalidEmail' }))
						.required(formatMessage({ id: 'errors.required' })),
					password: Yup.string()
						.required(formatMessage({ id: 'errors.required' }))
						.min(6, formatMessage({ id: 'errors.invalidPassword' })),
				})}
				onSubmit={(values, { setSubmitting }) => {
					setSubmitting(true);
					performLogin(values);
					setSubmitting(false);
				}}>
				{formik => (
					<form onSubmit={formik.handleSubmit}>
						<Grid columns="1">
							<Input
								name="email"
								type="email"
								label={formatMessage({ id: 'forms.email' })}
								placeholder={formatMessage({ id: 'forms.emailLabel' })}
							/>
							<Input
								name="password"
								type="password"
								label={formatMessage({ id: 'forms.password' })}
								placeholder={formatMessage({ id: 'forms.passwordLabel' })}
							/>
						</Grid>
						<Extra>
							<Grid
								columns="2"
								align="center">
								<div>
									<ForgotPassword href="/forgot-password">
										{formatMessage({ id: 'forms.forgetPassword' })}
									</ForgotPassword>
									<ForgotPassword href="/registro">
										{formatMessage({ id: 'forms.newUser' })}
									</ForgotPassword>
								</div>
								<Submit
									margin="0"
									justify="end"
									disabled={formik.isSubmitting}>
									{formatMessage({ id: 'forms.login' })}
								</Submit>
							</Grid>
						</Extra>
					</form>
				)}
			</Formik>
		</Wrap>
	);
};

const Wrap = styled.div`
	height: 100%;
`;

const Logo = styled.div`
	margin-bottom: 2em;
	img {
		display: block;
		max-width: 140px;
	}
`;

const Title = styled.div`
	margin-top: 100px;
	margin-bottom: 40px;
	h1 {
		font-size: 2.5rem;
		font-weight: bold;
		color: #000;
		margin: 0;
		span {
			color: ${props => props.theme.primaryColor};
		}
	}
	p {
		margin: 0;
		font-size: 1.25rem;
		color: #000;
	}
	@media screen and (max-width: 768px) {
	}
`;
const Extra = styled.div`
	margin-top: 2em;
`;
const ForgotPassword = styled.a`
	color: ${props => props.theme.primaryColor};
	font-weight: bold;
	font-size: 16px;
	text-decoration: underline;
	display: block;
	margin-bottom: 5px;
	&:hover {
		color: ${props => props.theme.primaryHoverColor};
	}
	@media screen and (max-width: 768px) {
		font-size: 10px;
	}
`;

export default Form;
